import React from 'react';
import PropTypes from 'prop-types';
import MostPopularLink from './most_popular_link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import {get} from 'lodash';

const MOST_POPULAR_FEATURE_FLAG = 'most_popular';

export const MostPopular = ({ mostPopular }, { location }) => {
  if (get(location, 'query.feature') !== MOST_POPULAR_FEATURE_FLAG) {
    return null;
  }

  return (
    <div className="most-popular">
      <span className="most-popular-header">
        <RosettaFormattedMessage parentFilename={__filename}
          id="header"
          description="Appears above the most popular section in articles"
          defaultMessage="Most Popular Stories"
        />
      </span>
      <div className="stories-container">
        {mostPopular.map(({ title, url }, index) =>
          <MostPopularLink
            key={index}
            title={title}
            url={url}
            index={index + 1}
          />
        )}
      </div>
    </div>
  );
};

MostPopular.propTypes = {
  mostPopular: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })).isRequired
};

MostPopular.contextTypes = {
  location: PropTypes.object
};

export default MostPopular;
